import { ReactNode } from 'react'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type DetailProps = WithClassName<{
	label: string
	value: ReactNode
	emphasis?: boolean
}>

export const Detail = ({ label, value, emphasis = false, className }: DetailProps) => (
	<div className={cn('min-w-0', className)}>
		<dt className="font-medium uppercase text-muted-foreground">{label}</dt>
		<dd className={cn('mt-0.5 truncate tabular-nums', emphasis ? 'font-semibold' : 'font-medium')}>
			{value}
		</dd>
	</div>
)
